import * as React from "react";

const Message = (props: {[key: string]: any}) => {
  return (
		<svg
		viewBox="0 0 24 24"
		fill="currentColor"
		height="1em"
		width="1em"
		{...props}
	>
		<path d="M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.516 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z" />
	</svg>
  );
};

export default Message;